import React from "react";
import PublicApply from "@/components/public/PublicApply";

export default function PartnerSignup() {
  return (
    <PublicApply
      role="partner"
      roleTestId="partner-signup"
      title="Plug your store into Lifted Supplies."
      blurb="Local smoke shops and retailers join the network to receive same-day orders from Lifted customers. 10% partner fee. Admin approval required."
      extraFields={[
        { key: "store_name", label: "Store name", placeholder: "Acme Smoke Shop" },
        { key: "store_address", label: "Store address", placeholder: "123 Main St, Suite B" },
        { key: "store_website", label: "Website (optional)", placeholder: "https://" },
      ]}
    />
  );
}
